module.exports = __webpack_public_path__ + "static/media/chains.eb355ac8.jpg";